import { Button as SSButton } from '@spaceshipapp/cambridge';
import withTracking from '../../hoc/withTracking';

export const fontSizeMap = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
};

export default withTracking('Button clicked')(SSButton);
